<template>
  <DashboardContainer>
    <PersonalDetails></PersonalDetails>
    <ChangePassword class="mt-2"></ChangePassword>
  </DashboardContainer>
</template>

<script>
import DashboardContainer from "../components/DashboardContainer";
import PersonalDetails from "../components/PersonalDetails";
import ChangePassword from "../components/ChangePassword";

export default {
  components: {
    DashboardContainer,
    PersonalDetails,
    ChangePassword
  },
  created() {
    document.title = "Settings - Landly Console";
  }
};
</script>